import React from 'react'
import useMediaQuery from 'utils/hooks/useMediaQuery';

const MobileProgress = ({ progressValue }) => {
  const isMobile = useMediaQuery("(max-width: 1200px)");

  return (
    isMobile && <progress max={100} value={progressValue} className="w-100 position-absolute step--progress_mobile" />
  )
}

export default MobileProgress;